import { z } from "zod";

export const referralExportRetryResponseSchema = z.object({ success: z.literal(true) });
